<template>
    <footer id="footer" class="jc-fe" v-if="$route.name !== 'Plano'">
        <div class="row m-0 flexContainer ai-c footer-container">
            <div @click="versioning" class="versionings col-12 col-sm-auto flexContainer jc-c justify-content-sm-start">
                <span>{{ $t("common.versioning") }}</span>
            </div>
            <div @click="showCGUModal();" class="versionings col-12 col-sm-auto flexContainer jc-c justify-content-sm-start">
                <span>{{ $t("cguModal.acronyme") }}</span>
            </div>
            <div
                class="adminTools col-12 col-sm-auto justify-content-center flexContainer justify-content-sm-start"
                @click="adminTools();"
                v-if="hasAccessSuperAdmin()"
            >
                <span>SuperAdmin Tools</span>
            </div>
            <div class="version col-12 col-sm flexContainer justify-content-center justify-content-sm-end">
                <span>{{ rem3rchVersion }} {{ $t("common.footerDate") }}</span>
            </div>
        </div>
    </footer>
</template>
<script>
import { mapActions } from "vuex";
import Globals from "@/components/globals";

export default {
    data() {
        return {};
    },
    components: {},
    computed: {
        rem3rchVersion() {
            return Globals.rem3rchVersion;
        }
    },
    methods: {
        ...mapActions("cguStore", {
            setShown: "setShown"
        }),
        versioning() {
            this.$router.push("/versionings");
        },
        adminTools() {
            this.$router.push("/brand-list");
        },
        showCGUModal() {
            this.setShown(true);
        }
    }
};
</script>
<style scoped lang="scss">
@import "../../assets/css/themes.scss";

#footer {
    .footer-container {
        @extend %third-background;
        @extend %primary-text;

        font-size: 1.3rem;
        min-height: 50px;

        .adminTools {
            padding: 10px;
        }

        .adminTools:hover {
            background-color: #6f6f6f;
            color: #fff;
            cursor: pointer;
        }

        .versionings {
            padding: 10px;
            display: inline-block;
            cursor: pointer;
        }

        .versionings:hover {
            background-color: #6f6f6f;
            color: #fff;
        }

        .version {
            padding: 10px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// Footer.vue?d3263fd8